import * as classnames from "classnames";

import { Icon, ChallengeCountDownTimer } from "../../components";
import { ApplicantExamModel, ApplicantChallengeModel } from "../../models/";

/**
 * Prop interface
 */
export interface ApplicantChallengeTitleColumnProps {
  exam: ApplicantExamModel;
  challenge: ApplicantChallengeModel;
  className?: string;
}

/**
 * React Component
 */
export default function ApplicantChallengeTitleColumn({
  className,
  challenge,
  exam,
}: ApplicantChallengeTitleColumnProps) {
  const rootStyle = classnames("code-c-applicant-challenge-title-column", {
    [`${className}`]: Boolean(className),
  });

  return (
    <div className={rootStyle}>
      <div className="code-c-applicant-challenge-title-column__row">
        <div
          className="code-c-applicant-challenge-title-column__title"
          title={challenge.title}
        >
          {challenge.title}
        </div>
        <div className="code-c-applicant-challenge-title-column__status">
          <span className="code-c-applicant-challenge-title-column__status-badge">
            {exam.getChallengeResultStatusLabel(challenge.id)}
          </span>
        </div>
      </div>
      <div className="code-c-applicant-challenge-title-column__row">
        <div className="code-c-applicant-challenge-title-column__timer">
          <Icon type="clock-o" />
          {exam.canChallengeStart(challenge.id) ? (
            challenge.getTimeLimitLabel()
          ) : (
            <ChallengeCountDownTimer
              className="code-c-applicant-challenge-title-column__timer-text"
              challengeId={challenge.id}
            />
          )}
        </div>
        <div className="code-c-applicant-challenge-title-column__question">
          {challenge.getQuestionCountLabel()}
        </div>
      </div>
    </div>
  );
}
